import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  Image,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import reportPdf from "../../images/icons/reportPdf.svg";

type TaxReportsCardProps = {
  to: string; // url the link should navigate to
};

export function TaxReportsCard({ to }: TaxReportsCardProps) {
  return (
    <Box
      alignSelf="flex-start"
      bg="white"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="lg"
      p={5}
      boxShadow="sm"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        justify="space-between"
        gap={4}
      >
        <Flex align="center" gap={3}>
          <Image
            src={reportPdf}
            boxSize={8}
            alt="Tax report icon"
            flexShrink={0}
          />
          <VStack align="start" spacing={2} flex={1}>
            <Heading size="sm">Looking for your tax reports?</Heading>
            <Text color="gray.600">
              Visit the Tax Reports page to view and download your reports.
            </Text>
          </VStack>
        </Flex>

        <Button
          as={Link}
          rightIcon={<ArrowForwardIcon />}
          to={to}
          flexShrink={0}
          alignSelf={{ base: "flex-start", md: "center" }}
        >
          Tax Reports
        </Button>
      </Flex>
    </Box>
  );
}
